import { React, useState } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Auth from "../Auth";
import Home from "../Home";
import Profile from "../tabs/Profile";
import Community from "tabs/Community";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { Link } from "react-router-dom";
import QRef from "tabs/QRef";
const AppRouter = ({ isLoggedIn }) => {
  const [value, setValue] = useState(window.location.pathname);
  console.log(isLoggedIn);
  return (
    <Router>
      <Switch>
        {isLoggedIn ? (
          <Route exact path="/">
            <Home />
          </Route>
        ) : (
          <Route exact path="/">
            <Auth />
          </Route>
        )}
      </Switch>
      <Route exact path="/Profile">
        <Profile />
      </Route>
      <Route exact path="/QRef">
        <QRef />
      </Route>
      <Route exact path="/Community">
        <Community />
      </Route>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        style={{
          position: "fixed",
          bottom: "0px",
          width: "100%",
          elevation: "3",
          height: "10%",
          backgroundColor: "#7b9acc",
        }}
      >
        <BottomNavigationAction
          component={Link}
          to="/Profile"
          label="프로필"
          icon={<AccountCircleOutlinedIcon />}
        />
        <BottomNavigationAction
          component={Link}
          to="/QRef"
          label="문제 풀기"
          icon={<QuizOutlinedIcon />}
        />
        <BottomNavigationAction
          component={Link}
          to="/Community"
          label="질문"
          icon={<ForumOutlinedIcon />}
        />
      </BottomNavigation>
    </Router>
  );
};

export default AppRouter;
